export default __webpack_public_path__ + "static/media/Stan-Ross.ae151e63.jpeg";